import { render, staticRenderFns } from "./VueMarkdown.vue.js?vue&type=template&id=383ff0ca&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./VueMarkdown.vue?vue&type=template&id=383ff0ca&scoped=true"
import script from "./VueMarkdown.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./VueMarkdown.vue?vue&type=script&lang=js"
export * from "./VueMarkdown.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./VueMarkdown.vue?vue&type=script&lang=js"
import style0 from "./VueMarkdown.vue.scss?vue&type=style&index=0&id=383ff0ca&lang=scss&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./VueMarkdown.vue?vue&type=style&index=0&id=383ff0ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ff0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383ff0ca')) {
      api.createRecord('383ff0ca', component.options)
    } else {
      api.reload('383ff0ca', component.options)
    }
    module.hot.accept("./VueMarkdown.vue.js?vue&type=template&id=383ff0ca&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./VueMarkdown.vue?vue&type=template&id=383ff0ca&scoped=true", function () {
      api.rerender('383ff0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/components/ChatFrame/VueMarkdown.vue"
export default component.exports